import { JetView, plugins } from 'webix-jet'; // Import necessary modules from webix-jet
import MenuView from '../menu'; // Import MenuView component
import ToolView from '../toolbar'; // Import ToolView component

/**
 * ComissionsView class extends JetView to create a view for managing commissions.
 */
export default class ComissionsView extends JetView {
    /**
     * Configures the layout of the ComissionsView.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service for text
        return {
            type: 'wide', // Layout type
            cols: [
                {
                    localId: 'inner:layout', // Local ID for inner layout
                    type: 'wide', // Inner layout type
                    rows: [
                        {
                            view: 'tabbar', // Tab bar for navigation
                            localId: 'tabbar', // Local ID for tab bar
                            height: 43, // Height of the tab bar
                            options: [
                                // Tab options
                                {
                                    id: 'betShopManagement.comissions.comissions', // ID for commissions tab
                                    value: _('Comisiones'), // Localized value for commissions
                                },
                                {
                                    id: 'betShopManagement.comissions.comissionsReportBetShop', // ID for commissions report tab
                                    value: _('Reporte de Comisiones'), // Localized value for commissions report
                                },
                                {
                                    id: 'betShopManagement.comissions.comissionsReportBetShopDetail', // ID for detailed commissions report tab
                                    value: _('Reporte de Comisiones Detallado'), // Localized value for detailed commissions report
                                },
                                {
                                    id: 'betShopManagement.comissions.withdrawalRequests', // ID for withdrawal requests tab
                                    value: _('Reporte de Retiros'), // Localized value for withdrawal reports
                                },
                            ],
                        },
                        { $subview: true }, // Placeholder for subview
                    ],
                },
            ],
        };
    }

    /**
     * Initializes the ComissionsView.
     */
    init() {
        webix.ready(function () {
            // Ensures webix is ready before executing
            webix.attachEvent('onRotate', function (orientation) {
                // Event for handling device rotation
                window.location.reload(); // Reloads the page on rotation
            });
        });
        this.use(plugins.Menu, this.$$('tabbar')); // Uses Menu plugin with the tab bar
        this.on(
            this.app,
            'person:select',
            (
                person, // Event listener for person selection
            ) => this.setParam('user', person.id, true), // Sets the selected person's ID as a parameter
        );
    }
}

// FILE DOCUMENTED
